import { useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import PrecertificacionActions from "../../../../stores/precertificacion/Actions";
import { useUpdateEffect } from "../../../../hooks/LifeCycle";
import TittleLine from "../../../../components/Common/TittleLine";
import {
  Section,
  LayoutContainer
} from "../../../../components/CustomLayout/CustomLayoutStyles";
import CustomTable from "../../../../components/CustomTable/CustomTable";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import ConsultarPrecertificacionesForm from "../components/ConsultarPrecertificacionesForm";
import Colors from "../../../../themes/Colors";
import standVirtualRoutes from "../../standVirtualRoutes";
import moment from "moment";
import { ALERTAS_GENERICAS } from "../../../../utils/AlertasGenericas";
import Pagination from "../../../../components/CustomTable/Pagination";
import CheckRender from "../../../../components/Common/CheckRender";
import Tooltip from "../../../../components/Common/Tooltip";
import CustomIcon from "../../../../components/Common/CustomIcon";
import { DownloadOutlined } from "@ant-design/icons";
import { isObjectEmpty } from "../../../../utils/ObjectUtil";
import CustomAlert from "../../../../components/Common/CustomAlert";
import { mostrarErrorGenerico } from "../../../../utils/AlertUtils";
import ModalLoader from "../../../../components/Common/ModalLoader";
import useEmpresa from "../../../../hooks/useEmpresa";
import CustomMainNavBar from "../../../../components/CustomHeader/CustomMainNavBar";
import { MainContent } from "../../styles/MainLayoutStandVirtualStyles";
import { useSelector } from "react-redux";
import { QUERY_RANGE, TIME_SCALE } from "../../../../utils/Constant";

const PrecertificacionesConsultarScreen = (props) => {
  const history = useHistory();
  const empresa = useEmpresa();
  const authUserData = useSelector((state) => state.auth.authUserData);

  const goTo = (path) => {
    history.push(path);
  };

  const [formData, setFormData] = useState({
    fechaDesde: moment()
      .subtract(QUERY_RANGE.uno, TIME_SCALE.dia)
      .format("YYYY-MM-DD"),
    fechaHasta: moment().format("YYYY-MM-DD"),
    numeroSolicitud: "",
    numeroPlastico: "",
    estatus: "Todos"
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const [processing, setProcessing] = useState(false);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [precertificaciones, setPrecertificaciones] = useState([]);
  const [totalRegistros, setTotalRegistros] = useState(0);

  /**
   * Consultar precertificaciones Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.consultarPrecertificacionesData) && processing) {
      setProcessing(false);

      const data =
        props?.consultarPrecertificacionesData?.precertificaciones || [];
      setPrecertificaciones(data);

      setTotalRegistros(
        props?.consultarPrecertificacionesData?.paginacion?.totalRegistros || 0
      );

      if (data.length === 0) {
        setAlertConfig({
          type: "info",
          title: "¡Hola!",
          message:
            "No se encontraron precertificaciones con los criterios indicados.",
          onConfirm: () => {
            setShowAlert(false);
          }
        });
        setShowAlert(true);
      }
    }
  }, [props.consultarPrecertificacionesData]);

  /**
   * Consultar precertificaciones Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.consultarPrecertificacionesError) && processing) {
      setProcessing(false);

      setPrecertificaciones([]);

      mostrarErrorGenerico(
        props?.consultarPrecertificacionesError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.consultarPrecertificacionesError]);

  /**
   * Descargar voucher Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.descargarVoucherPrecertificacionError)) {
      setAlertConfig({
        type: "error",
        title: "Error",
        message:
          props?.descargarVoucherPrecertificacionError?.mensaje ||
          "No se pudo descargar el voucher. Por favor, intente nuevamente.",
        onConfirm: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
    }
  }, [props.descargarVoucherPrecertificacionError]);

  const onStateChange =
    (key, format = null) =>
    (value) => {
      setFormData((prevState) => ({
        ...prevState,
        [key]: format ? format(value) : value
      }));
    };

  const buscarSolicitudes = (pagina = currentPage) => {
    const { fechaDesde, fechaHasta } = formData;

    const fechaDesdeValor = fechaDesde
      ? moment(fechaDesde).format("YYYY-MM-DD")
      : null;
    const fechaHastaValor = fechaHasta
      ? moment(fechaHasta).format("YYYY-MM-DD")
      : null;

    let mensajeValidacion = null;

    if (moment(fechaDesdeValor).isAfter(fechaHastaValor)) {
      mensajeValidacion = ALERTAS_GENERICAS.FECHA_DESDE_HASTA_INVALIDA;
    }

    if (mensajeValidacion) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: mensajeValidacion,
        onConfirm: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
      return;
    }

    setProcessing(true);

    props.consultarPrecertificaciones({
      ...formData,
      fechaDesde: fechaDesdeValor,
      fechaHasta: fechaHastaValor,
      compania: empresa?.CODIGO,
      pagina: pagina,
      tamanoPagina: itemsPerPage,
      codigoPss: authUserData?.prestador?.codigo,
      tipoPss: authUserData?.prestador?.tipoPss
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    buscarSolicitudes(page);
  };

  const handleNuevaSolicitud = () => {
    const createNewRequest = `/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacionNueva.route}`;
    goTo(createNewRequest);
  };

  const verDetalleSolicitud = (record) => {
    const detalleSolicitud = `/${
      standVirtualRoutes.base.route
    }/${standVirtualRoutes.precertificacionVer.route.replace(
      ":id",
      record.id
    )}`;
    goTo(detalleSolicitud);
  };

  const descargarVoucher = (record) => {
    if (!record.id) return;

    props.descargarVoucherPrecertificacion({
      numeroSolicitud: record.id
    });
  };

  const showModalLoader = () => {
    return (
      props.consultarPrecertificacionesLoading ||
      props.descargarVoucherPrecertificacionLoading
    );
  };

  const columns = [
    {
      title: "No. Solicitud",
      key: "numeroSolicitud",
      dataIndex: "numeroSolicitud",
      render: (text, record) => (
        <button
          type="button"
          style={{
            color: Colors.primaryPrimera,
            cursor: "pointer",
            transition: "all 0.3s ease",
            textDecoration: "none",
            background: "none",
            border: "none",
            padding: "8px",
            textAlign: "left",
            width: "100%",
            fontSize: "14px",
            fontWeight: "500"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = Colors.darkGreenPrimera;
            e.currentTarget.style.textDecoration = "underline";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = Colors.primaryPrimera;
            e.currentTarget.style.textDecoration = "none";
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            verDetalleSolicitud(record);
          }}
        >
          {text}
        </button>
      )
    },
    // {
    //   title: "No. Autorización",
    //   key: "numeroAutorizacion",
    //   dataIndex: "numeroAutorizacion"
    // },
    {
      title: "Fecha",
      key: "fecha",
      dataIndex: "fecha",
      render: (text, record) => {
        return moment(record.fecha).format("L");
      }
    },
    {
      title: "Asegurado",
      key: "asegurado",
      dataIndex: "asegurado"
    },
    {
      title: "Estado",
      key: "estado",
      dataIndex: "estado"
    },
    {
      title: "Descargar Voucher",
      key: "descargarVoucher",
      dataIndex: "descargarVoucher",
      render: (_, record) => {
        const tooltipText = "Descargar Voucher";

        return (
          <Tooltip text={tooltipText} position="top">
            <CustomIcon
              icon={DownloadOutlined}
              onClick={() => descargarVoucher(record)}
            />
          </Tooltip>
        );
      }
    }
  ];

  useUpdateEffect(() => {
    setShowAlert(false);
    setAlertConfig({});
  }, []);

  return (
    <LayoutContainer>
      <CustomMainNavBar />
      <MainContent>
        <Section>
          <TittleLine
            title={"Stand Virtual"}
            customButton={
              <CustomButton
                label="Nueva Solicitud"
                bgColor={Colors.darkGreenPrimera}
                hoverColor={Colors.LightGreenPrimera}
                textColor={Colors.white}
                hoverTextColor={Colors.white}
                onClick={handleNuevaSolicitud}
                width="200px"
                fontSize="16px"
              />
            }
          />
        </Section>

        <Section>
          <ConsultarPrecertificacionesForm
            {...formData}
            onStateChange={onStateChange}
            onSearch={() => buscarSolicitudes(currentPage)}
            isLoading={props.consultarPrecertificacionesLoading}
          />
        </Section>

        <Section
          style={{
            padding: "0px",
            flexDirection: "column",
            gap: "10px",
            alignItems: "center"
          }}
        >
          <CheckRender allowed={precertificaciones?.length > 0}>
            <CustomTable
              columns={columns}
              dataSource={precertificaciones}
              showPagination={false}
              pageSize={itemsPerPage}
              width={"100%"}
            />
            <Pagination
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              totalItems={totalRegistros}
              onPageChange={handlePageChange}
            />
          </CheckRender>
        </Section>

        <CheckRender allowed={showModalLoader()}>
          <ModalLoader />
        </CheckRender>

        <CheckRender allowed={showAlert}>
          <CustomAlert {...alertConfig} />
        </CheckRender>
      </MainContent>
    </LayoutContainer>
  );
};

const mapStateToProps = (state) => ({
  consultarPrecertificacionesData:
    state.precertificacion.consultarPrecertificacionesData,
  consultarPrecertificacionesLoading:
    state.precertificacion.consultarPrecertificacionesLoading,
  consultarPrecertificacionesError:
    state.precertificacion.consultarPrecertificacionesError,
  descargarVoucherPrecertificacionLoading:
    state.precertificacion.descargarVoucherPrecertificacionLoading,
  descargarVoucherPrecertificacionError:
    state.precertificacion.descargarVoucherPrecertificacionError
});

const mapDispatchToProps = {
  consultarPrecertificaciones:
    PrecertificacionActions.consultarPrecertificaciones,
  descargarVoucherPrecertificacion:
    PrecertificacionActions.descargarVoucherPrecertificacion
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(PrecertificacionesConsultarScreen);
